export enum AlertsMenuVariant {
  Outside = 'outside',
  Inside = 'inside',
}
